import { getSecondaryColor } from "./activeColor";

export const getFontStyle = (fontSize: string) => {
  const style = {
    color: getSecondaryColor() !== 'white' ? 'white' : "", // Set to 'white' if textColor is defined and not 'white', otherwise 'inherit'
  };

  switch (fontSize) {
    case 'font-medium':
      return {
        ...style,
        fontSize: '1.25em',
        lineHeight: '1.5em',
      };
    case 'font-large':
      return {
        ...style,
        fontSize: '1.5rem',
        lineHeight: '1.15em',
      };
    default:
      return {
        ...style,
        fontSize: '1rem',
      };
  }
};
